import { Stack } from '@mui/material'
import { C1CircularProgress } from 'c1ui/components/C1CircularProgress'
import { FC } from 'react'

export const C1FullPageLoadingSpinner: FC = () => (
    <Stack sx={{ height: '60vh', alignItems: 'center', justifyContent: 'center' }}>
        <C1CircularProgress />
    </Stack>
)
